var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { SubmissionDeadlineConfiguration } from "./SubmissionDeadlineConfiguration";
export class SearchResult {
  constructor(_data) {
    /**
     */
    __publicField(this, "SubmissionDeadlineConfigurations");
    /**
     */
    __publicField(this, "TotalCount");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof SearchResult
     */
    __publicField(this, "$type", "V1.SubmissionDeadlineConfigurations.Search.SearchResult");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      if (_data["SubmissionDeadlineConfigurations"] && _data["SubmissionDeadlineConfigurations"].constructor === Array) {
        this.SubmissionDeadlineConfigurations = [];
        for (let item of _data["SubmissionDeadlineConfigurations"]) {
          const submissionDeadlineConfigurations_ = new SubmissionDeadlineConfiguration();
          this.SubmissionDeadlineConfigurations.push(submissionDeadlineConfigurations_.init(item));
        }
      }
      this.TotalCount = _data["TotalCount"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    if (this.SubmissionDeadlineConfigurations && this.SubmissionDeadlineConfigurations.constructor === Array) {
      _data["SubmissionDeadlineConfigurations"] = [];
      for (let item of this.SubmissionDeadlineConfigurations) {
        _data["SubmissionDeadlineConfigurations"].push(item.toJSON());
      }
    }
    _data["TotalCount"] = this.TotalCount;
    return _data;
  }
}
